import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { SiteDepartmentCard, SiteDepartmentService } from '../site-department.service';
import { SiteDataState } from '../site-utils';

@Component({
  selector: 'ws-site-specialty-cards',
  templateUrl: './specialty-cards.component.html'
})
export class SiteSpecialtyCardsComponent implements OnDestroy {
  @Input() gridClass = 'specialty-feature-grid';
  @Input() limit = 0;

  state: SiteDataState = 'loading';

  private readonly subs = new Subscription();
  private all: SiteDepartmentCard[] = [];

  constructor(departments: SiteDepartmentService) {
    this.subs.add(departments.state$.subscribe(s => this.state = s));
    this.subs.add(departments.cards$.subscribe(c => this.all = c));
  }

  get cards(): SiteDepartmentCard[] {
    return this.limit > 0 ? this.all.slice(0, this.limit) : this.all;
  }

  ngOnDestroy() { this.subs.unsubscribe(); }

  number(i: number): string { return i < 9 ? '0' + (i + 1) : String(i + 1); }

  trackById(_: number, card: SiteDepartmentCard) { return card.id; }
}
